const PHEV_RANGE = 55;
const UK_GALLON_TO_LITERS = 4.54;
const MPG_PHEV = 50;
const FUEL_PRICE_PHEV = 1.36;
const EV_CHARGE_COST_PHEV = 1.26;

export const getMonthlyAndYearlySavings = (
  dailyCommuteValue,
  averageConsumptionValue,
  fuelPrice
) => {
  const paidMileagePhev = dailyCommuteValue - PHEV_RANGE;

  const paidMileagePetrolDiesel = dailyCommuteValue;

  const gallonsPhev = paidMileagePhev / MPG_PHEV;

  const gallonsPetrolDiesel = paidMileagePetrolDiesel / averageConsumptionValue;

  const litresUsedPhev = gallonsPhev * UK_GALLON_TO_LITERS;

  const litresUsedPetrolDiesel = gallonsPetrolDiesel * UK_GALLON_TO_LITERS;

  const phevCost = litresUsedPhev * FUEL_PRICE_PHEV + EV_CHARGE_COST_PHEV;

  const petrolDieselConst = litresUsedPetrolDiesel * Number(fuelPrice);

  const phevSavings = petrolDieselConst - phevCost;

  const weeklyPhevSavings = phevSavings * 5;
  const monthlyPhevSavings = weeklyPhevSavings * 4;
  const yearlyPhevSavings = monthlyPhevSavings * 12;

  return {
    monthlyPhevSavings: monthlyPhevSavings < 0 ? 0 : monthlyPhevSavings,
    yearlyPhevSavings: yearlyPhevSavings < 0 ? 0 : yearlyPhevSavings,
  };
};
